import styled from 'styled-components';
import background_navy_shapes from 'assets/testimonials/background_navy_shapes.png';
import { BREAKPOINTS } from 'constants/common';

import { Checkbox, Input, StaticTooltip } from 'Components';
import { Label } from 'Components/Common/styled';

export const LabelStyled = styled(Label)`
  /* @media (min-width: ${BREAKPOINTS.tablet}px) {
    width: 48%;

    &:nth-child(odd) {margin-right: 2%;}
    &:nth-child(even) {margin-left: 2%;}
  }

  @media (min-width: ${BREAKPOINTS.desktop}px) {
    width: 45%;

    &:nth-child(odd) {margin-right: 5%;}
    &:nth-child(even) {margin-left: unset;}
  } */

  &[for='firstName'],
  &[for='lastName'] {
    width: 47%;
    display: inline-block;
    vertical-align: top;
  }

  &[for='firstName'] {
    margin-right: 3%;
  }

  &[for='lastName'] {
    margin-left: 3%;
  }

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    width: 100%;
  }
`;

export const Wrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 23px;

  .rightCol {
    width: 50%;
    margin-left: 100px;
    display: flex;
    flex-direction: column;
  }

  .password-errors-tooltip {
    opacity: 1 !important;
    background: var(--white);
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: ${BREAKPOINTS.desktop - 1}px) {
    flex-direction: column;
    align-items: center;

    .rightCol {
      width: 100%;
      margin: 0;

      .testimonial {
        display: none;
      }
    }
  }
`;

export const FormContainer = styled.div`
  width: 100%;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    width: 420px;
    flex-shrink: 0;
  }
`;

export const Form = styled.form`
  @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin-top: 26px;
  }
`;

export const InputStyled = styled(Input)`
  margin-top: 6px;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin-top: 8px;
  }
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: calc(100% + 1px);
  transition: opacity 0.35s 0.5s linear;
  left: -99999px;
  opacity: 0;
  visibility: hidden;
`;

export const ButtonWrap = styled.div`
  margin-top: 5px;
  position: relative;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin-top: 2px;
  }

  &:hover {
    ${TooltipWrapper} {
      @media (min-width: ${BREAKPOINTS.tablet}px) {
        visibility: visible;
        left: 0;
        opacity: 1;
      }
    }
  }
`;

export const PasswordErrorDialogWrap = styled.div`
  position: absolute;
  top: 100px;
  left: 0;

  @media (max-width: ${BREAKPOINTS.desktop - 1}px) {
    width: 100%;
  }
`;

export const PasswordErrorDialogItem = styled.li<{ valid: boolean }>`
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  color: ${props => (props.valid ? '#66B913' : 'var(--errorRed)')};

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    margin-right: 10px;
    width: 11px;
    &.checked {
      width: 12px;
      margin-right: 9px;
    }
  }
`;

export const DisabledTooltip = styled(StaticTooltip)`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: var(--white);
  padding: 12px 27px;
  margin: auto;
`;

export const PasswordErrorDialog = styled(StaticTooltip)`
  font-weight: normal;
  .title {
    font-weight: 500;
    margin: 0 0 8px 0;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
`;

export const Description = styled.div`
  margin-top: 8px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
`;

export const Title = styled.div`
  color: var(--Text-T01, #333);
  text-align: center;

  font-size: 24px;
  font-style: normal;
  font-weight: 400;

  @media (max-width: ${BREAKPOINTS.desktop - 1}px) {
    display: none;
  }
`;

export const TitleMobile = styled(Title)`
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  display: block;
  margin-top: 2px;
  letter-spacing: -0.8px;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: none;
  }
`;

export const MobileMessage = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  background: url(${background_navy_shapes}), var(--primary);
  background-size: 100% 100%, auto;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 10px;
  color: #fff;
  padding: 20px 13px;
  margin-top: 15px;
  letter-spacing: -0.6px;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: none;
  }
`;

export const MobileMessageTitle = styled.div`
  font-weight: 700;
  font-size: 15px;
  line-height: 19px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 10px;
  letter-spacing: -1px;
`;

export const SignInLink = styled.a`
  color: var(--black);
  text-decoration: none;
  font-weight: 500;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    text-decoration: underline;
    color: var(--primary);
  }
`;

export const SignInLinkText = styled.span`
  display: none;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: inline;
  }
`;

export const SignInLinkTextMobile = styled.span`
  display: inline;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: none;
  }
`;

export const SignInLinkWrapper = styled.div`
  margin-bottom: 10px;
  margin-top: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin-bottom: 17px;
    font-weight: 500;
  }
`;

export const Relative = styled.div`
  position: relative;
  width: 258px;
  margin: auto;
`;

export const ActionsWrapper = styled.div`
  margin-top: 16px;
  /* @media (min-width: ${BREAKPOINTS.tablet}px) {
    width: 48%;
    margin-left: 2%;
  }

  @media (min-width: ${BREAKPOINTS.desktop}px) {
    width: 45%;
    margin-right: 5%;
    margin-left: 0;
  } */
`;

export const CheckboxStyled = styled(Checkbox)`
  display: inline-block;
  margin: auto;
  width: 330px;

  /* @media (min-width: ${BREAKPOINTS.tablet}px) {
    margin: 19px 0;
    width: 45%;
    margin-right: 5%;
  } */
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    flex-direction: row;
  }
`;
